import api from '../commonJs/http.js'
import store from '../store/index.js'

const _import = require('@/router/_import_' + process.env.NODE_ENV)

function LoadMenu(router, routes, childrenIndex, to, next, NProgress,requireauth) {
  //判断菜单数据
    if ((!(store.state.menuData && store.state.menuData.length > 0)) && to.path != '/Error' && to.path != '/NoAuth' && to.path != '/Login') {
      const data = require("../assets/Menus.json");
      store.commit("saveMenuData", data.data.menu);
      store.commit("saveProjectData", data.data.projectInfo);
      store.commit("saveYunWeiInfo", data.data.yunWeiInfo);
      //设置首页重定向,这里将获取的菜单pid=0中第一项的不为#的url作为首页
      //这里没有直接在代码中设置main重定向，原因是菜单中配置url时可能会设置些url参数
      let indexModual = data.data.menu.filter(function (m) {
        return m.ParentID == "0";
      });
      if (indexModual[0].Url != undefined && indexModual[0].Url != null && indexModual[0].Url != '#' && indexModual[0].Url != '') {
        let redirect = CreateIndexRedirect(indexModual[0]);

        let queryArr = Object.keys(to.query);
        for (let i = 0; i < queryArr.length; i++) {
          const item = queryArr[i];
          redirect.query[item] = to.query[item];
        }
        routes[childrenIndex].redirect = redirect;
        //设置菜单首页选中
        if (!window.sessionStorage.getItem('curMenu')) {
          store.commit('setCurMenu', indexModual[0].Url);
        }

      }
      else {
        let indexPage = data.data.menu.filter(function (m) {
          return m.ParentID == indexModual[0].ID;
        });
        let redirect = CreateIndexRedirect(indexPage[0]);
        let queryArr = Object.keys(to.query);
        for (let i = 0; i < queryArr.length; i++) {
          const item = queryArr[i];
          redirect.query[item] = to.query[item];
        }
        routes[childrenIndex].redirect = redirect;
        //设置菜单首页选中
        if (!window.sessionStorage.getItem('curMenu')) {
          store.commit('setCurMenu', indexPage[0].Url);
        }
      }
        if(requireauth){
          api.get("/Main/GetUserInfo",null,
                function (res) {
                  if (res.code == 200) {
                    store.commit("saveCurUserInfo", res.data[0]);
                    store.commit("saveCurUserAttr", res.data[1]);
                    // getAttr(res.data[1]);//获取权限
                  }
                  if(res.code==410){
                    RedirectLogin();
                  }
                }
            )
        }
      try {
        router.addRoutes(routes);
      } catch (error) {
        console.log(error);
      }
      next({ ...to, replace: true });//replace属性为true的时候可以让链接在跳转的时候不会留下历史记录
      }
      else {
        if (to.path.startsWith("/Layout") && to.query["Src"]) {
          //保存Src到store中，去除url中的Src,
          store.commit("saveIframeLayoutSrc", decodeURIComponent(to.fullPath.replace('/Layout?Src=','')));
          let queryParam = {};
          for (var p in to.query) {
            if (p != "Src") {
              queryParam[p] = to.query[p];
            }
          }
        
          next({ path: to.path, query: queryParam });
        }
        else {
          NProgress.done();
          next();
        }

  }
}

//获取权限
function getAttr(attrInfo) {
  let userAttrArr = attrInfo.User;
  if (userAttrArr) {
    let curAuditArr= userAttrArr.filter(e => e.SYSATTRIBUTENAME === '运维审核权限');
    if (curAuditArr[0]) {
      store.commit("saveYWAudit", curAuditArr[0].SYSATTRIBUTEVALUE);
    }
  }
}

function CreateIndexRedirect(item) {

  let redirect = { path: '', query: {} };
  let urlArr = item.Url.split('?');
  redirect.path = urlArr[0];
  if (urlArr.length == 2) {
    let paramArr = urlArr[1].split('&');
    for (let i = 0; i < paramArr.length; i++) {
      let element = paramArr[i];
      redirect.query[element.split('=')[0]] = element.split('=')[1]
    }
  }
  return redirect;
}
function RedirectLogin() {
  // let to = window.location.href;
  let to =window.location.protocol +"//" +window.location.host +(window.location.pathname == "/" ? "/" : window.location.pathname) +"#/Admin/Index"; //这里重定向要加后面/#/
  let loginUrl = process.env.VUE_APP_LOGIN_URL+"login?RedirectUrl=" + encodeURIComponent(to) + "&sysid=" + process.env.VUE_APP_SYSID;
  window.location.href = loginUrl;
}

export default {
  LoadMenu: function (router, routes, childrenIndex, to, next, NProgress,requireauth) {
    return LoadMenu(router, routes, childrenIndex, to, next, NProgress,requireauth);
  }
}